import React, { memo } from "react";
import clsx from "clsx";
import isEqual from "react-fast-compare";
import {
  List,
  ListItemIcon,
  ListItemText,
  Paper,
  Fade,
  ListItemButton,
  Theme,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import {
  Description,
  CorporateFare,
  SvgIconComponent,
} from "@mui/icons-material";
import { NavLink, useLocation, NavLinkProps } from "react-router-dom";
import { HOME_PAGE, ORGANIZATIONS_PAGE } from "../../util/constants";

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    padding: `0 ${theme.spacing(1)}`,
    margin: `${theme.spacing(2)} 0 ${theme.spacing(2)} ${theme.spacing(2)}`,
  },
  listItem: {
    display: "flex",
    flexDirection: "column",
    borderRadius: 4,
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5),
    paddingTop: theme.spacing(1.2),
    paddingBottom: theme.spacing(0.7),
    marginBottom: theme.spacing(0.5),
    textDecoration: "none",
    outline: "none",
    "& > div": {
      display: "flex",
      justifyContent: "center",
    },
  },
  itemText: {
    "& span": {
      fontSize: "0.9rem !important",
      color: theme.palette.text.primary,
    },
  },
  active: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
    "& > div, span": {
      color: "white",
    },
  },
}));

const NavLinkComponent = memo((props: NavLinkProps) => {
  const classes = useStyles();
  return (
    <NavLink
      {...props}
      className={({ isActive }: { isActive: boolean }) =>
        clsx(classes.listItem, {
          [classes.active]: isActive,
        })
      }
    />
  );
}, isEqual);

const Sidebar = () => {
  const classes = useStyles();
  const { pathname }: { pathname: string } = useLocation();

  if (pathname.startsWith("/vouchers/edit")) return null;

  const renderNavItem = (
    label: string,
    to: string,
    end: boolean,
    Icon: SvgIconComponent
  ) => {
    return (
      <ListItemButton component={NavLinkComponent} end={end} to={to}>
        <ListItemIcon>
          <Icon />
        </ListItemIcon>
        <ListItemText className={classes.itemText} primary={label} />
      </ListItemButton>
    );
  };

  return (
    <Fade in={true}>
      <Paper className={classes.wrapper}>
        <List component="nav">
          {renderNavItem("Vouchers", HOME_PAGE, true, Description)}
          {renderNavItem(
            "Organizations",
            ORGANIZATIONS_PAGE,
            false,
            CorporateFare
          )}
        </List>
      </Paper>
    </Fade>
  );
};

export default Sidebar;
